import { render } from "./WordListTrial3.vue?vue&type=template&id=19c8c71c&scoped=true"
import script from "./WordListTrial3.vue?vue&type=script&lang=js"
export * from "./WordListTrial3.vue?vue&type=script&lang=js"

import "./WordListTrial3.vue?vue&type=style&index=0&id=19c8c71c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c8c71c"]])

export default __exports__